// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1cdn1","content":"ManualTimeModal_content__3IAaT"};